export {
  DashboardCard,
  type DashboardCardProps,
} from '../../compositions/shared/DashboardCard';
